export const INFINITE_PLACEHOLDER = "Inf";
